﻿import * as utils from "./utils.js";
import * as campjogos from "./campjogos.js";
import {initLotinha} from "./lotinha.js";

let divBanner;

let local;

export function ativaAtualizacao() {
  window.intervaloAtualizacao = setInterval(function () {
    ConsultarCamp();
    window.ConsultarJogos(-4)
  }, 360000);
}

export function desativaAtualizacao() {
  clearInterval(window.intervaloAtualizacao);
  window.intervaloAtualizacao = null;
}

$(document).ready(function () {
  window.divCamp = $('#grdCamp');
  window.divJogos = $('#grdJogos');
  window.divBilhete = $("#grdApostas");
  window.lbNjogos = $("#lbNJogos");

  $(".modalBack").click(function () {
    $(".modalWindow2, .modalBack").fadeOut('fast');
    $('body').removeClass('noscroll');
  });

  utils.avisoAguarde();

  window.PegaConfig(function () {

    campjogos.MontaBilhete();
    if ($("#EditVlAposta").length) {
      campjogos.AplicarCopiaBilhete();
    }

    $("#EditVlAposta").on("change paste keyup", function () {
      window.CalcularGanho();
    });

    window.SaldoUser();

    ConsultarEsportes();

    ativaAtualizacao();
    setInterval(SaldoUser, 60000);

    if (window.config.Auth.LOGIN) {
      $("#btConfirmar").prop("value", "Confirmar");
    } else {
      $("#btConfirmar").prop("value", "Pré-bilhete");
    }

    window.initLotinha = initLotinha;

    $("#hpyTab").hide();
    $("#hpyCaixa").hide();
    $("#hpyAdm").hide();
    $("#hpyLotinha").hide();

    if (window.config.loto_ativo) {
      $("#hpyLotinha").show();
    }

    if (window.config.Auth.ID > 0) {
      //$("#hpyTab").show();
      $("#hpyCaixa").show();
      if (window.config.Auth.NIVEL > 0) {
        $("#hpyAdm").show();
      }
    }
  });

});

function ConsultarEsportes() {

  $.ajax({
    url: url + "enet/Esportes",
    type: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    processdata: true,
    success: function (data) {
      PopularEsportes(data);
    },
    error: function (xhr) {
      console.log(xhr)
    }
  });

}

function PopularEsportes(data) {
  var options = '';
  $("#ddEsportes").html("");

  localStorage.EsporteId = '0';

  $.each(data, function (key, val) {
    var def = '';
    if (val.PADRAO == 1) {
      localStorage.EsporteId = '' + val.ID;
      def = 'selected';
    }
    options += '<option value="' + val.ID + '" ' + def + ' >' + val.NOME + '</option>';
  });

  $("#ddEsportes").html(options);

  $("#ddEsportes").change(function () {

    var str = "";

    $("#ddEsportes option:selected").each(function () {
      str += $(this).val();
    });

    if (str == "") {
    } else {
      localStorage.EsporteId = str;

      ConsultarCamp();

      window.ConsultarJogos(-2);
    }
  }).change();
}


window.ConsultarCamp = function() {
  let filtro = "?esporte=" + localStorage.EsporteId;

  $.ajax({
    url: url + "enet/Campeonatos" + filtro,
    type: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    processdata: true,
    success: function (data) {
      MontarGradeCamp(data);
    },
    error: function (xhr) {
      console.log(xhr)
    }
  });
}


function MontarGradeCamp(data) {
  window.divCamp.html("");

  let row = "<ul><li><a href='javascript:window.ConsultarJogos({id})'>{descricao}</a></li></ul>";
  let linhas = row.replace("{id}", "-1").replace("{descricao}", "Todos");

  if ((localStorage.EsporteId != "101") && (localStorage.EsporteId != "102")) {
    var d = new Date();
    var dt_formatada = d.toLocaleDateString("pt-BR", {day: '2-digit', month: '2-digit', year: '2-digit'});
    linhas += row.replace("{id}", "-2").replace("{descricao}", "Jogos de hoje (" + dt_formatada + ")");
    d.setDate(d.getDate() + 1);
    dt_formatada = d.toLocaleDateString("pt-BR", {day: '2-digit', month: '2-digit', year: '2-digit'});
    linhas += row.replace("{id}", "-3").replace("{descricao}", "Jogos de amanhã (" + dt_formatada + ")");
  }
  if (config.aovivo === 'sim') {
    linhas += "<ul><li><a style='display:flex;' href='javascript:window.ConsultarJogos(-5)'>Jogos ao vivo <div class=\"blob red\"></div></a></li></ul>";
  }

  for (let i = 0; i < data.length; i++) {
    let id = data[i].CAMP_ID;
    let descricao = data[i].CAMP_NOME;

    linhas += row.replace("{id}", id).replace("{descricao}", descricao);
  }

  window.divCamp.append(linhas);
}

window.SaldoUser = function () {
  $.ajax({
    url: url + "enet/Saldo",
    type: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    processdata: true,
    success: function (data) {
      $("#lbSaldoUser").html("Meu saldo: R$ " + data.saldo.toFixed(2));
    },
    error: function (xhr) {
      $("#lbSaldoUser").html("");
    }
  });
}
